// extracted by mini-css-extract-plugin
module.exports = {"container":"UserCardSection_container__uKJZj","title":"UserCardSection_title__2-Mmv","card_section":"UserCardSection_card_section__1-jfg"};